import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';

import { redirectToViewerCorrection } from '../../lib/utils';
import { generateClassroomCorrectionViewerPayload, clearAndRedirect } from './utils';

import { CORRECTION } from '../../constants/routes';
import { AskForGoogleLogin, MissingScopesMessage } from '../classwork-login-component';
import { useGapi } from '../../lib/hooks';

const ClassWorkLoginCorrectionComponent = ({
    assignment,
    assignmentId,
    getAssignmentById,
    googleUserInfo,
    googleUserStatus,
    requestAccessToken,
    resumeGoogleLogin,
    status,
    statusId,
    getStatusById,
    setGoogleCourseWorkId,
}) => {
    const history = useNavigate();
    const [gApiStatus] = useGapi();

    useEffect(() => {
        setGoogleCourseWorkId();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (gApiStatus.success && !googleUserInfo) {
            resumeGoogleLogin();
        }
    }, [googleUserInfo, gApiStatus.success, resumeGoogleLogin]);

    useEffect(() => {
        if (!assignmentId || !statusId) {
            clearAndRedirect(history, CORRECTION);
        } else if (googleUserStatus.success && googleUserInfo?.grantedScopes) {
            getAssignmentById(assignmentId);
            getStatusById(statusId);
        }
    }, [googleUserStatus.success, getAssignmentById, assignmentId, getStatusById, statusId, history, googleUserInfo]);

    useEffect(() => {
        const statusReady = !status.httpStatus.fetching && status.httpStatus.loaded;

        if (statusReady && (assignment.httpStatus.error || status.httpStatus.error)) {
            clearAndRedirect(history, CORRECTION);
        }

        if (!assignment.error && assignment.classId && statusReady && googleUserStatus.success) {
            const payload = generateClassroomCorrectionViewerPayload(assignment, status);
            if (payload === null) {
                clearAndRedirect(history, CORRECTION);
                return;
            }
            redirectToViewerCorrection(payload);
        }
    }, [assignment, status, googleUserStatus.success, history]);

    if (!googleUserStatus.pending && !gApiStatus.pending) {
        if (!googleUserStatus.gotAccessToken) {
            return <AskForGoogleLogin reSignIn={requestAccessToken} />;
        } else if (!googleUserInfo.grantedScopes) {
            return <MissingScopesMessage reSignIn={requestAccessToken}></MissingScopesMessage>;
        }
    }
    return <></>;
};

ClassWorkLoginCorrectionComponent.propTypes = {
    assignment: PropTypes.object,
    assignmentId: PropTypes.string,
    getAssignmentById: PropTypes.func,
    googleUserInfo: PropTypes.object,
    googleUserStatus: PropTypes.shape({
        error: PropTypes.bool,
        gotAccessToken: PropTypes.bool,
        pending: PropTypes.bool,
        success: PropTypes.bool,
    }),
    status: PropTypes.object,
    statusId: PropTypes.string,
    getStatusById: PropTypes.func,
    requestAccessToken: PropTypes.func,
    resumeGoogleLogin: PropTypes.func,
    setGoogleCourseWorkId: PropTypes.func,
};

export default ClassWorkLoginCorrectionComponent;
